import Echo from "laravel-echo"
import Pusher from "pusher-js"
import store from "@/store/index"
import helpers from "@/helpers/index"

let kioskMainEchoInstance = null
let kioskActivePassEchoInstance = null

const createEchoInstance = (authToken = null) => {
  if (import.meta.env.VITE_SOCKET_PROVIDER == "SOKETI") {
    window.Pusher = require("pusher-js")
    return new Echo({
      broadcaster: "pusher",
      key: import.meta.env.VITE_PUSHER_APP_KEY,
      wsHost: import.meta.env.VITE_PUSHER_WS_HOST,
      wsPort: import.meta.env.VITE_PUSHER_WS_PORT,
      cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
      forceTLS: true,
      disableStats: true,
      enabledTransports: ["ws", "wss"],
      ...(authToken
        ? {
            authEndpoint: `${import.meta.env.VITE_AUTH_URL}/api/v5/broadcasting/auth`,
            auth: {
              headers: {
                Authorization: "Bearer " + authToken
              }
            }
          }
        : {})
    })
  }

  if (import.meta.env.VITE_SOCKET_PROVIDER == "REVERB") {
    window.Pusher = Pusher
    const reverbScheme = import.meta.env.VITE_REVERB_SCHEME ?? "http"
    const reverbHost = (
      import.meta.env.VITE_REVERB_HOST ??
      import.meta.env.VITE_WS_HOST ??
      "localhost"
    ).split(":")[0]

    return new Echo({
      broadcaster: "reverb",
      key: import.meta.env.VITE_REVERB_APP_KEY,
      wsHost: reverbHost,
      wsPort: import.meta.env.VITE_REVERB_PORT,
      wssPort: import.meta.env.VITE_REVERB_PORT,
      forceTLS: reverbScheme == "https",
      enabledTransports: ["ws", "wss"],
      ...(authToken
        ? {
            authEndpoint: `${import.meta.env.VITE_AUTH_URL}/api/v5/broadcasting/auth`,
            auth: {
              headers: {
                Authorization: "Bearer " + authToken
              }
            }
          }
        : {})
    })
  }

  window.io = require("socket.io-client")
  return new Echo({
    broadcaster: "socket.io",
    host: import.meta.env.VITE_WS_HOST,
    encrypted: import.meta.env.VITE_WS_ENCRYPTED === "true",
    transports: ["websocket"],
    ...(authToken
      ? {
          authEndpoint: `${import.meta.env.VITE_AUTH_URL}/api/v5/broadcasting/auth`,
          auth: {
            headers: {
              Authorization: "Bearer " + authToken
            }
          }
        }
      : {})
  })
}

const initKioskModeSockets = () => {
  const EchoInstance = createEchoInstance()

  const directLoginToken = localStorage.getItem("kioskDirectLoginToken")

  EchoInstance.channel(`kiosks.${directLoginToken}`).listen(
    "Tardy\\KioskLatePassCreationToggled",
    (payload) => {
      store.commit("kiosks/SET_ACTIVE_KIOSK_LATES", payload.values)
    }
  )

  kioskMainEchoInstance = EchoInstance
}
const initKioskModePreferencesChannel = () => {
  kioskMainEchoInstance
    .channel(`user.preferences.kiosk`)
    .listen("ProfilePreferencesKioskEvent", () => {
      store.dispatch("favorites/getFavorites", { clearCacheEntry: true })
    })
}
const initKioskModePassSockets = (activePassId) => {
  const EchoInstance = createEchoInstance(
    localStorage.getItem("kioskAccessToken")
  )

  const kioskUserPassChannel = EchoInstance.private(
    `kiosks.user.${activePassId}`
  )

  kioskUserPassChannel.listen(
    "QueueManagement\\QueuePassCanceled",
    (payload) => {
      // eslint-disable-next-line no-console
      console.log("QueueManagement \\ QueuePassCanceled", payload)
      if (payload?.queuePass) {
        store.commit("kiosks/SET_CLOSE_KIOSK_ACTIVE_PASS_SCREEN", true)
      } else {
        store.commit("kiosks/SET_CLOSE_KIOSK_ACTIVE_PASS_SCREEN", false)
      }
      if (payload?.notifyStudent) {
        helpers.playNotificationSound({ playQueueSound: true })
      }
    }
  )

  kioskUserPassChannel.listen("QueueManagement\\QueuePassMoved", (payload) => {
    // eslint-disable-next-line no-console
    console.log("QueueManagement \\ QueuePassMoved", payload)
    if (payload?.queuePass) {
      store.commit("kiosks/REPLACE_ACTIVE_PASS", payload?.queuePass)
      if (payload?.notifyStudent) {
        helpers.playNotificationSound({ playQueueSound: true })
      }
    }
  })

  kioskUserPassChannel.listen(
    "QueueManagement\\QueuePassConverted",
    (payload) => {
      // eslint-disable-next-line no-console
      console.log("QueueManagement \\ QueuePassConverted", payload)
      if (payload?.pass) {
        store.commit("kiosks/REPLACE_ACTIVE_PASS", payload?.pass)
        if (payload?.notifyStudent) {
          helpers.playNotificationSound({ playQueueSound: true })
        }
      }
    }
  )

  kioskUserPassChannel.listen("PassApproved", (payload) => {
    if (payload && payload.pass) {
      store.commit("kiosks/REPLACE_ACTIVE_PASS", payload.pass)
    }
  })

  kioskActivePassEchoInstance = EchoInstance
}
const destroyKioskModePassSockets = () => {
  kioskActivePassEchoInstance.disconnect()
}

export {
  initKioskModeSockets,
  initKioskModePreferencesChannel,
  initKioskModePassSockets,
  destroyKioskModePassSockets
}
